import * as globalConfig from './globals'

declare const RUNTIME_SERVER_CONFIG: globalConfig.IServerConfig

export default {
  loadServerConfig: (): globalConfig.IServerConfig => {
    if (RUNTIME_SERVER_CONFIG) {
      return RUNTIME_SERVER_CONFIG
    }

    return globalConfig.GLOBAL_SERVER_CONFIG
  },
}
